define(
	'actions/clips',[
	"jquery",
	"underscore",
	"backbone",
	"react",
	"dispatcher/AppDispatcher",
	"constants/actiontypes"
	],
	function($,_,Backbone,React,AppDispatcher,Constants){
		return Backbone.Model.extend({
			init: function(params) {
			},
			addItem: function(params) {
				AppDispatcher.dispatch({
					actionType: Constants.CREATED_CLIP,
					data: params
				});
			},
			updatedItem: function(guid, params) {
				AppDispatcher.dispatch({
					actionType: Constants.UPDATED_CLIP,
					guid: guid,
					data: params
				});
			},
			deletedItem: function(guid) {
				AppDispatcher.dispatch({
					actionType: Constants.DELETED_CLIP,
					guid: guid
				});
			},
			pull: function(parent, onComplete) {
				var self = this;
				var items = [];
				
				window.api.request("clips").each(function iterator (index, item) {
					items.push({
						guid: item.guid,
						title: item.buncee_title,
						buncee_owner_name: item.buncee_owner_name,
						buncee_owner: item.buncee_owner,
						thumbnail_url: item.thumbnail_url,
						slide_orginal_order: item.slide_original_order,
						created_at: item.created_at,
						deleted_at: item.deleted_at,
						updated_at: item.updated_at,
						creation_version: item.creation_version,
						canvas_size: item.slide.canvas ? item.slide.canvas.size_type : undefined,
					});
				}, function () {
					self.addItem(items);
					if (typeof onComplete === "function") {
						onComplete();
					}
				});
			},
			delete: function(guid) {
				var self = this;
				window.api.request("clips", guid)
				.delete({})
				.done(function (response) {
					console.log("Clip Deleted");
					self.deletedItem(guid);
				})
				.fail(function (jqXHR, textStatus, errorThrown) {
					console.error(jqXHR);
					alert("Uh-Oh!", jqXHR.responseText || "Your request could not be completed at this time.", {
						message: "Dismiss"
					});
				});
			}
		});
	}
);
